import React, { useCallback, useEffect, useRef, useState } from "react";
import LabsPage from "./LabsPage.js";
import LabsHeader from "../Components/LabsHeader.jsx";
import { LAB_SERVICES } from "../labs/services.js";
import { fetchLabCatalog } from "../utils/labCatalog.js";
import { mergeBundledServices } from "../utils/labs.js";

export default function LabsCatalogPage() {
  // Keep the existing deployed tools usable during the backend rollout/outages.
  // A successful response is merged with the bundled registry so a deployed page
  // is listed without waiting for a separate catalog registration.
  const [services, setServices] = useState(null);
  const [status, setStatus] = useState("loading");
  const currentRequest = useRef(null);
  const mounted = useRef(false);

  const refresh = useCallback(async () => {
    currentRequest.current?.abort();
    const controller = new AbortController();
    currentRequest.current = controller;
    const timeout = setTimeout(() => controller.abort(), 10000);
    setStatus("loading");
    try {
      const catalog = await fetchLabCatalog({ signal: controller.signal });
      if (mounted.current && currentRequest.current === controller) {
        setServices(mergeBundledServices(catalog, LAB_SERVICES));
        setStatus("ready");
      }
    } catch (_) {
      if (mounted.current && currentRequest.current === controller) {
        setServices((previous) => previous ?? LAB_SERVICES);
        setStatus("error");
      }
    } finally {
      clearTimeout(timeout);
    }
  }, []);

  useEffect(() => {
    mounted.current = true;
    refresh();
    const onFocus = () => { if (document.visibilityState !== "hidden") refresh(); };
    window.addEventListener("focus", onFocus);
    return () => {
      mounted.current = false;
      currentRequest.current?.abort();
      window.removeEventListener("focus", onFocus);
    };
  }, [refresh]);

  // Mount the directory after the first response so its saved filters/scroll
  // are restored against the current catalog instead of a temporary fallback.
  if (services === null) return <><LabsHeader /><p role="status" style={{ padding: 24, textAlign: "center" }}>서비스 목록을 확인하고 있어요…</p></>;
  return <LabsPage services={services} catalogStatus={status} onRefresh={refresh} />;
}
